import { useMediaQuery } from "@material-ui/core";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AthlinksAds } from "../../components/shared/Banner";
import { Promo } from "../../components/IRP/body/IRPPromo";
import { useExtra } from "../../hooks/useExtra";
import { theme } from "../../shared/theme";

type EventSponsorsProps = {
  eventId: number | null
  masterId: number | null
}

const EventSponsors = ({ eventId, masterId }: EventSponsorsProps) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { extra } = useExtra(masterId, eventId)
  const sponsors = extra?.sponsors

  const athlinksAdItems = useMemo(() => {
    if (Array.isArray(sponsors) && !sponsors.length) {
      return AthlinksAds.adsForPage('IndividualResults')
    }

    return []
  }, [sponsors])

  return (
    <Promo
      adUnits={athlinksAdItems}
      isMobile={isMobile}
      sponsors={sponsors || []}
      t={t}
    />
  )
}

export { EventSponsors }